package meineglasfaser.frontend.www.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.rememberPageContext
import io.ktor.client.call.*
import kotlinx.coroutines.flow.MutableStateFlow
import meineglasfaser.api.CustomerAccountInfo
import meineglasfaser.api.routes.CustomerPortalRoutes
import meineglasfaser.frontend.common.BackendApi
import meineglasfaser.frontend.common.components.widgets.Toast
import meineglasfaser.frontend.common.components.widgets.Toasts
import meineglasfaser.frontend.common.withAuth

sealed interface CustomerState {
    data object Indeterminate : CustomerState

    data class LoggedIn(val accountInfo: CustomerAccountInfo) : CustomerState

    data object LoggedOut : CustomerState

    fun accountInfoOrNull(): CustomerAccountInfo? {
        return when (this) {
            is LoggedIn -> accountInfo
            else -> null
        }
    }
}

val GlobalCustomerState = MutableStateFlow<CustomerState>(CustomerState.Indeterminate)

val LocalCustomerState = compositionLocalOf<CustomerState> { CustomerState.Indeterminate }

@Composable
fun ProvideCustomerState(content: @Composable () -> Unit) {
    val state by GlobalCustomerState.collectAsState()

    LaunchedEffect(state) {
        if (state != CustomerState.Indeterminate) return@LaunchedEffect
        BackendApi.get<CustomerPortalRoutes.Account.BaseInfo>(CustomerPortalRoutes.Account.BaseInfo()) {
            withAuth()
        }.fold(
            onSuccess = { response ->
                GlobalCustomerState.value = CustomerState.LoggedIn(
                    response.body<CustomerAccountInfo>()
                )
            },
            onFailure = { error ->
                console.error(error.stackTraceToString())
                GlobalCustomerState.value = CustomerState.LoggedOut
            }
        )
    }

    CompositionLocalProvider(LocalCustomerState provides state) {
        content()
    }
}

@Composable
fun CustomerStateRedirectIfLoggedIn() {
    val ctx = rememberPageContext()
    val state = LocalCustomerState.current

    LaunchedEffect(state) {
        if (state is CustomerState.LoggedIn) {
            ctx.router.navigateTo("/kundenportal/overview")
            Toasts.display(
                Toast.info(
                    title = "Bereits angemeldet",
                    message = "Willkommen!",
                )
            )
        }
    }
}

@Composable
fun CustomerStateRedirectIfLoggedOut() {
    val ctx = rememberPageContext()
    val state = LocalCustomerState.current

    LaunchedEffect(state) {
        if (state is CustomerState.LoggedOut) {
            ctx.router.navigateTo("/kundenportal/auth/login")
            Toasts.display(
                Toast.info(
                    title = "Anmeldung erforderlich",
                    message = "Das Kundenportal kann nur nach Anmeldung benutzt werden",
                )
            )
        }
    }
}
